import type { GalleryPhoto } from '../types';
import { apartmentsData } from './apartments';

// Stavros village + Ithaca scenic placeholders (replace with local owner photos later)
const scenicPhotos: GalleryPhoto[] = [
  //{ id: 201, imageUrl: '/images/gallery/stavros/1.jpg', caption: 'Stavros rooftops at golden hour', category: 'stavros', displayOrder: 1 },
  //{ id: 202, imageUrl: '/images/gallery/stavros/2.jpg', caption: 'Stavros harbour view', category: 'stavros', displayOrder: 2 },
  //{ id: 203, imageUrl: '/images/gallery/stavros/3.jpg', caption: 'Old stone alleys', category: 'stavros', displayOrder: 3 },
  { id: 204, imageUrl: '/images/gallery/ithaca/ithaki_1.jpg', caption: 'Ithaki coast at sunset', category: 'ithaca', displayOrder: 1 },
  { id: 205, imageUrl: '/images/gallery/ithaca/ithaki_2.jpg', caption: 'Seaside road toward village', category: 'ithaca', displayOrder: 2 },
  { id: 206, imageUrl: '/images/gallery/ithaca/ithaki_3.jpg', caption: 'Ithaki shoreline from above', category: 'ithaca', displayOrder: 3 },
  { id: 207, imageUrl: '/images/gallery/ithaca/ithaki_4.jpg', caption: 'Rocky coast and blue water', category: 'ithaca', displayOrder: 4 },
  { id: 208, imageUrl: '/images/gallery/ithaca/ithaki_5.jpg', caption: 'Late-afternoon harbour view', category: 'ithaca', displayOrder: 5 },
  { id: 209, imageUrl: '/images/gallery/ithaca/ithaki_6.jpg', caption: 'Sunset over the Ionian', category: 'ithaca', displayOrder: 6 },
  { id: 210, imageUrl: '/images/gallery/ithaca/ithaki_7.jpg', caption: 'Mountain path with a view', category: 'ithaca', displayOrder: 7 },
  { id: 211, imageUrl: '/images/gallery/ithaca/ithaki_8.jpg', caption: 'Scenic overlook', category: 'ithaca', displayOrder: 8 },
];

function getApartmentGalleryPhotos(): GalleryPhoto[] {
  return apartmentsData.flatMap((apt) =>
    apt.photos.map((p) => ({
      id: p.id,
      imageUrl: p.imageUrl,
      caption: `${apt.name} \u2014 ${p.caption}`,
      category: 'apartment' as const,
      displayOrder: p.displayOrder,
      suiteId: apt.id,
    })),
  );
}

export function getGalleryPhotosBySuiteId(suiteId: number): GalleryPhoto[] {
  return getApartmentGalleryPhotos()
    .filter((p) => p.suiteId === suiteId)
    .sort((a, b) => a.displayOrder - b.displayOrder);
}

export function getGalleryPhotos(category?: GalleryPhoto['category']): GalleryPhoto[] {
  const all = [...getApartmentGalleryPhotos(), ...scenicPhotos];
  if (category) {
    return all.filter((p) => p.category === category).sort((a, b) => a.displayOrder - b.displayOrder);
  }
  return all;
}

export function getGalleryCategories(): Array<{ key: GalleryPhoto['category'] | 'all'; count: number }> {
  const all = [...getApartmentGalleryPhotos(), ...scenicPhotos];
  return [
    { key: 'all', count: all.length },
    { key: 'apartment', count: all.filter((p) => p.category === 'apartment').length },
    { key: 'stavros', count: all.filter((p) => p.category === 'stavros').length },
    { key: 'ithaca', count: all.filter((p) => p.category === 'ithaca').length },
  ];
}
